import ServiceGraphQL from 'src/service/gql-service';
import { changePassword } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

export const ChangePassword = (variables) => {
  const params = {
    query: changePassword.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
